module.exports = __webpack_public_path__ + "img/INTERIOR-BALENO-4.2ceee325.jpg";